import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** EB-3 — PHALANGE. Le bouclier qui n'est pas le sien.
 *
 *  L'Égide et le Rempart posent un cône protecteur pour se protéger EUX-MÊMES :
 *  le contourner, c'est atteindre leur propre ventre. La Phalange retourne
 *  l'intention. Son cône est large et elle avance en TÊTE d'une formation : le
 *  cône ne couvre pas tant son corps qu'il abrite le PIÈGE derrière elle — les
 *  tireurs légers qu'elle mène et qui, eux, n'ont aucune défense.
 *
 *  ── Ce qu'elle enseigne ──
 *  Que la bonne cible n'est pas toujours celle qui vous tire dessus. Un joueur
 *  qui arrose droit devant use son feu sur le cône de la Phalange pendant que
 *  l'escorte le grignote depuis l'abri. La solution n'est pas plus de dégâts,
 *  c'est un DÉPLACEMENT : se décaler sur le flanc, là où le cône ne regarde pas,
 *  d'où l'on atteint d'un coup et la Phalange ET l'escorte qu'elle couvrait.
 *  Casser l'escorte revient à casser l'ordre de priorité — la même compétence
 *  que l'Égide (se placer pour toucher), mais dont l'enjeu est le GROUPE et non
 *  l'individu.
 *
 *  ── Pourquoi ±62° et pas plus ──
 *  Entre l'Égide (±55°, une épaule facile) et le Rempart (±80°, presque tout
 *  fermé). La Phalange doit se contourner sans devoir monter à sa hauteur : elle
 *  mène une formation qui descend, le joueur reste sous elle, et un pas de flanc
 *  franc doit suffire à trouver l'angle. Trop fermée, contourner exigerait de
 *  quitter la formation des yeux ; or c'est la formation qu'il faut lire.
 *
 *  ── Pourquoi une pression légère ──
 *  Comme l'Égide et le Rempart : deux tirs visés espacés. Son rôle n'est pas de
 *  faire mal mais d'ABRITER — le danger est l'escorte, pas elle. La noyer sous un
 *  rideau ferait choisir survivre plutôt que se placer, et le porteur perdrait sa
 *  raison d'être. Elle a donc besoin de son escorte pour exister : seule, c'est
 *  un exercice de flanc ; en tête d'une nuée, c'est un arbitrage de cible. */
export default defineEnemy({
  id: 'phalange',
  rank: Rank.Heavy,
  hp: 460,
  visualRadius: 46,
  score: 520,
  telegraph: 1.1,
  drops: 4,
  /* Elle DESCEND en tête, à vitesse modérée : la formation la suit et le joueur
     reste sous elle. Pas de station haute comme l'Égide — le combat se joue en
     bas de terrain, là où l'escorte devient une vraie menace. */
  motion: { kind: Motion.Linear, speed: 62, amplitude: 0, frequency: 0, holdY: 0 },
  /* 620 PV de bouclier : casser de front reste possible mais long, et pendant ce
     temps l'escorte travaille. Le contournement est la route qui règle les deux
     problèmes d'un même geste. */
  shieldHp: 620,
  shieldConeDeg: 62,
  emitter: {
    pattern: Pattern.Aimed,
    every: 1.6,
    count: 2,
    spreadDeg: 15,
    speed: 450,
    firstDelay: 1.5,
    family: Fam.EnemyPink,
  },
});
